import React, { useEffect, useState } from "react";
import "./styles.scss";
import "react-notifications-component/dist/theme.css";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { Button, FormHeader, InputBox } from "../../../components";
import { CheckValidity } from "../../../utils/formValidity";
import { useDispatch, useSelector } from "react-redux";
import CategorySelectBox from "../../templates/categorySelectBox";
import { Store } from "react-notifications-component";
import { v4 as uuidv4 } from "uuid";
import {
  createSubCategory,
  createSuperCategory,
  updateAdvSubCategory,
} from "../CreateNewAdvertisement/service/advertisement.service";
import AdvertismentSelectBox from "../../templates/advertisementSelectBox";
import {
  addAdvCategoryList,
  clearedSelectItems,
} from "../../advertisement/redux/actions";

const CreateNewAdvCategory = () => {
  const dispatch = useDispatch();
  const selectAdvCategory = useSelector(
    (state) => state.advertismentReducer.selectAdvCategory
  );
  const [language, setLanguage] = useState("si");

  const [formData, setFormData] = useState({
    superCategory: {
      key: "superCategory",
      label: "Super Category Name",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    category: {
      key: "category",
      label: "Super Category",
      size: "lg",
      placeholder: "-",
      mainLayerStyles: " flex-column " + " align-content-center " + "mb-3",
      iconName: "",
      isRequired: false,
      loading: false,
      elementConfig: {
        options: [{ value: "", displayValue: "-- Select Category --" }],
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    subCategory: {
      key: "subCategory",
      label: "Sub Category Name",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = async (event, inputIdentity) => {
    const updateForm = {
      ...formData,
    };

    updateForm[inputIdentity].value = event;
    let validityRes = await CheckValidity(
      inputIdentity,
      updateForm[inputIdentity].value,
      updateForm[inputIdentity].validation
    );

    if (validityRes) {
      updateForm[inputIdentity].isValid = validityRes.isValid;
      updateForm[inputIdentity].invalidReason = validityRes.reason;
      updateForm[inputIdentity].value = event;
      updateForm[inputIdentity].touched = true;
      console.log("required_validation", validityRes);

      let formIsValid = false;
      for (let inputIdentifier in updateForm) {
        formIsValid = updateForm[inputIdentifier].valid && formIsValid;
      }
      console.log("formIsValid", formIsValid);
      setFormData(updateForm);
    }
  };

  const categorySelect = (value) => {
    console.log({ value });
    const updateForm = { ...formData };
    updateForm["category"].value = value;
    setFormData(updateForm);
  };

  const clearAll = () => {
    const updateForm = {
      ...formData,
    };
    for (let key in updateForm) {
      updateForm[key].value = "";
      updateForm[key].isValid = false;
      updateForm[key].touched = false;
    }
    setFormData(updateForm);
  };

  useEffect(() => {
    if (selectAdvCategory?.category_id) {
      console.log("id", selectAdvCategory.category_id);
      const updatedForm = {
        ...formData,
      };
      updateForm["superCategory"].value = selectAdvCategory.category_name;
      updateForm["category"].elementConfig.options = [
        {
          value: selectAdvCategory.category_id,
          displayValue: selectAdvCategory.category_name,
        },
      ];
      updateForm["subCategory"].value = selectAdvCategory.sub_category_name;

      setFormData(updatedForm);
    } else {
      for (let key in updateForm) {
        console.log(updateForm[key]);
        updateForm[key].value = "";
        updateForm[key].isValid = false;
        updateForm[key].touched = false;
      }
      setFormData(updateForm);
    }
  }, [selectAdvCategory]);

  const onClickCreate = async () => {
    setIsLoading(true);
    setIsButtonDisabled(true);

    const updateForm = { ...formData };

    const response = await createSuperCategory({
      category_name: updateForm.superCategory.value,
    });
    console.log("Super Category Response:", response);
    setIsLoading(false);

    try {
      if (response?.data) {
        console.log("Super Category Created Successfully");
        Store.addNotification({
          title: "Success!",
          message: "Super Category Created Successfully!",
          type: "success",
          insert: "top",
          container: "top-right",
          dismiss: { duration: 3000, onScreen: true },
        });
        setIsLoading(false);
        setIsButtonDisabled(false);
        clearAll();
      }
    } catch (error) {
      console.log("Error creating Super Category");
      Store.addNotification({
        title: "Error!",
        message: "Super Category Create Failed!",
        type: "danger",
        insert: "top",
        container: "top-right",
        dismiss: { duration: 3000, onScreen: true },
      });
      setIsLoading(false);
      setIsButtonDisabled(false);
      clearAll();
    }
  };

  const onClickSave = async () => {
    setIsLoading(true);
    setIsButtonDisabled(true);

    const updateForm = { ...formData };

    try {
      if (
        updateForm.category.value !== "" &&
        updateForm.subCategory.value !== ""
      ) {
        let body = {
          category_id: updateForm.category.value,
          sub_category: {
            sub_category_id: uuidv4(),
            sub_category_name: updateForm.subCategory.value,
          },
        };
        const response = await createSubCategory(body);

        console.log("Sub Category Response:", response);
        Store.addNotification({
          title: "Success!",
          message: "Sub Category Updated Successfully!",
          type: "success",
          insert: "top",
          container: "top-right",
          dismiss: { duration: 3000, onScreen: true },
        });
        setIsLoading(false);
        dispatch(
          addAdvCategoryList({
            category_id: updateForm.category.value,
            category_name: response?.data?.category_name,
            sub_category_id: body.sub_category.sub_category_id,
            sub_category_name: updateForm.subCategory.value,
          })
        );
        clearAll();
      }
    } catch (error) {
      console.log("Error creating Sub Category");
      Store.addNotification({
        title: "Error!",
        message: "Sub Category Create Failed!",
        type: "danger",
        insert: "top",
        container: "top-right",
        dismiss: { duration: 3000, onScreen: true },
      });
      setIsLoading(false);
      setIsButtonDisabled(false);
      clearAll();
    }
  };

  const onClickUpdate = async () => {
    setIsLoading(true);
    setIsButtonDisabled(true);

    if (selectAdvCategory?.category_id) {
      const updateForm = { ...formData };
      const body = {
        category_name: updateForm.superCategory.value,
        sub_category: {
          sub_category_id: selectAdvCategory.sub_category_id,
          sub_category_name: updateForm.subCategory.value,
        },
      };
      console.log("Update Body", body);
      const response = await updateAdvSubCategory(
        body,
        selectAdvCategory.category_id,
        selectAdvCategory.sub_category_id
      );
      console.log("Update Response", response);
      setIsLoading(false);
      try {
        if (response?.data) {
          Store.addNotification({
            title: "Success!",
            message: "Sub Category Updated Successfully!",
            type: "success",

            insert: "top",
            container: "top-right",
            dismiss: { duration: 3000, onScreen: true },
          });
          setIsLoading(false);
          setIsButtonDisabled(false);
          clearAll();
        }
      } catch (error) {
        Store.addNotification({
          title: "Error!",
          message: "Sub Category Update Failed!",
          type: "danger",
          insert: "top",
          container: "top-right",
          dismiss: { duration: 3000, onScreen: true },
        });
        setIsLoading(false);
        setIsButtonDisabled(false);
        clearAll();
      }
    }
  };

  const updateForm = { ...formData };

  return (
    <>
      <div className="hne-create-adv-category-wrapper">
        <FormHeader
          data={{
            formHeader: "Create Adv Category",
            size: "md-md",
          }}
        />

        <InputBox
          data={updateForm.superCategory}
          onChange={async (e) => {
            e.preventDefault();
            await handleChange(e.target.value, updateForm.superCategory.key);
          }}
        />

        <Button
          data={{
            btnName: "DONE",
            buttonType:
              updateForm.superCategory.value === "" ||
              selectAdvCategory?.category_id
                ? "primary disabled"
                : "primary",
            buttonSize: "lg",
            isLoading: isLoading,
            disable:
              updateForm.superCategory.value === "" ||
              selectAdvCategory?.category_id
                ? true
                : false,
          }}
          onClick={async (e) => {
            e.preventDefault();
            await onClickCreate(e);
          }}
        />
        <div className="adv_line"></div>

        <div className="advc_select-wrapper">
          <AdvertismentSelectBox
            onChangeCategory={categorySelect}
            data={{
              type: "superCategory",
            }}
          />

          <InputBox
            data={updateForm.subCategory}
            onChange={async (e) => {
              e.preventDefault();
              await handleChange(e.target.value, updateForm.subCategory.key);
            }}
          />
        </div>
        <div className="d-flex flex-row justify-content-between">
          {selectAdvCategory?.category_id && (
            <Button
              data={{
                btnName: "Clear",
                buttonType: "secondary mr-2",
                buttonSize: "lg",
                isLoading: isLoading,
              }}
              onClick={async (e) => {
                e.preventDefault();
                dispatch(clearedSelectItems());
                clearAll();
              }}
            />
          )}

          <Button
            data={{
              btnName: selectAdvCategory?.category_id ? "UPDATE" : "SAVE",
              buttonType:
                updateForm.category.value === "" ||
                updateForm.subCategory.value === ""
                  ? "primary disabled"
                  : "primary",
              buttonSize: "lg",
              isLoading: isLoading,
              disable:
                updateForm.category.value === "" ||
                updateForm.subCategory.value === ""
                  ? true
                  : false,
            }}
            onClick={async (e) => {
              e.preventDefault();
              if (selectAdvCategory?.category_id) {
                await onClickUpdate(e);
              } else {
                await onClickSave(e);
              }
            }}
          />
        </div>
      </div>
    </>
  );
};
export default withRouter(CreateNewAdvCategory);
